"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegLiveintent = void 0;
const base_1 = require("./base");
const liveintent_1 = require("../services/liveintent");
/**
 * Liveintent
 */
class AnIntegLiveintent extends base_1.AnIntegBase {
    static isLoaded() {
        return liveintent_1.AnServLiveintent.isLoaded();
    }
    static sendTrackClubCheckoutStart(siteCategory) {
        liveintent_1.AnServLiveintent.sendEventAddToCartSubscription(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackArriveSignupLoginLegacy(siteCategory) {
        liveintent_1.AnServLiveintent.sendEventAddToCartSubscription(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackClubAccountCreate(siteCategory, userId, email) {
        liveintent_1.AnServLiveintent.sendConversionEmailSignup(this.getPixelId(siteCategory), email);
        return true;
    }
    static sendTrackClubAccountCreateLegacy(siteCategory, userId, email) {
        liveintent_1.AnServLiveintent.sendConversionEmailSignup(this.getPixelId(siteCategory), email);
        return true;
    }
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        liveintent_1.AnServLiveintent.sendConversionProductPurchase(this.getPixelId(siteCategory), userId, email);
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        liveintent_1.AnServLiveintent.sendConversionProductPurchase(this.getPixelId(siteCategory), userId, email);
        return true;
    }
}
exports.AnIntegLiveintent = AnIntegLiveintent;
AnIntegLiveintent.shouldSendTrackClubCheckoutStart = true;
AnIntegLiveintent.shouldSendTrackArriveSignupLoginLegacy = true;
AnIntegLiveintent.shouldSendTrackClubAccountCreate = true;
AnIntegLiveintent.shouldSendTrackClubAccountCreateLegacy = true;
AnIntegLiveintent.shouldSendTrackClubThankyou = true;
AnIntegLiveintent.shouldSendTrackClubThankyouLegacy = true;
AnIntegLiveintent.pixelId = {
    prod: {
        defaultId: "a-06l2",
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: "a-06l2",
        ecomm: null,
        club: null,
    },
};
